import React, { useContext, createContext, useEffect } from "react";
import { GoDownload } from "react-icons/go";
import ActionBlueButton from "./ActionBlueButton";
import LoanAction from "../pages/LoanAction/LoanAction";
import { LoanActionContext } from "../pages/LoanAction/LoanAction";
import { decryptText } from "../utils/cipherText";
import { MdOutlineCancel } from "react-icons/md";

function InvokeTopBar({
  invocationState,
  setInvocationState,
  searchValue,
  setSearchValue,
  invokeCount,
  setInitiateModal,
  setCancelModal,
  readOnly,
}) {
  const current = useContext(LoanActionContext);
  const userType = decryptText(localStorage.getItem("lender_type"), 7);

  let text = "";
  // if (current==="invoke" && invocationState === "list") text = `Initiate Invoke (${invokeCount})`;
  // else text = `Invoke Now (${invokeCount})`;

  if (current === "invoke") {
    if (invocationState === "list") {
      invokeCount === 0
        ? (text = `Initiate Invoke`)
        : (text = `Initiate Invoke (${invokeCount})`);
    } else {
      invokeCount === 0
        ? (text = `Invoke Now`)
        : (text = `Invoke Now (${invokeCount})`);
    }
    // text = `Invoke Now (${invokeCount})`;}
  } else {
    if (invocationState === "list") {
      invokeCount === 0
        ? (text = `Initiate Revoke`)
        : (text = `Initiate Revoke (${invokeCount})`);
    } else {
      invokeCount === 0
        ? (text = `Revoke Now`)
        : (text = `Revoke Now (${invokeCount})`);
    }
  }

  useEffect(() => {
    console.log(current + "current");
  }, []);
  return (
    <div className=" px-4 mt-[18px] flex justify-between items-center bg-white pt-3">
      <div className="rounded-[23px] bg-[#f8f8f8] text-sm font-semibold p-1 inline-block">
        <button
          className={`${
            invocationState === "list" ? "bg-[#92e86c]" : ""
          } px-[45px] py-[7px] rounded-[19px]`}
          onClick={() => setInvocationState("list")}
        >
          Alert List
        </button>
        {userType === "admin" && (
          <button
            className={`${
              invocationState === "initiatedInvocation" ? "bg-[#92e86c]" : ""
            } px-[14px] py-[7px] rounded-[19px]`}
            onClick={() => setInvocationState("initiatedInvocation")}
          >
            {current === "invoke"
              ? "Initiated Invocation"
              : "Initiated Revocation"}
          </button>
        )}
      </div>
      <div className="flex items-center">
        <div className="flex items-center pr-3 border-r border-[#e0e0e0] mr-3">
          <div className="relative w-[210px]">
            <input
              type="text"
              placeholder="Search"
              readOnly={readOnly}
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
              }}
              className="w-full text-xs h-8 border border-[#e0e0e0] rounded bg-[#f8f8f8] px-4 py-[14px] pr-10 focus:outline-none"
            />
            {searchValue && (
              <button
                onClick={() => setSearchValue("")}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 focus:outline-none"
              >
                <MdOutlineCancel color="#00394d" />
              </button>
            )}
          </div>
          {/* <button className=" border rounded border-[#dadada] py-[7px] px-3">
            <GoDownload fontSize={"16px"} color="#656565" />
          </button> */}
        </div>
        <div className="flex">
          {invocationState === "initiatedInvocation" && (
            <button
              disabled={invokeCount === 0}
              onClick={() => setCancelModal(true)}
              className={`text-sm  border  rounded py-[3px] px-4 mr-3 font-semibold ${
                invokeCount === 0
                  ? " border-[#aaaaaa] text-[#aaaaaa]"
                  : "border-[#00394d] text-[#00394d]"
              }`}
            >
              {current === "invoke" ? "Cancel Invoke" : "Cancel Revoke"}
            </button>
          )}{" "}
          <ActionBlueButton
            text={text}
            setInvokeModal={setInitiateModal}
            disabled={invokeCount === 0}
          />
        </div>
      </div>
    </div>
  );
}

export default InvokeTopBar;
